<template lang="pug">
  div.lmm-content-body-padded
    b-container(fluid)
      b-row
        b-col.page-wrap(cols="12")
          div.page-header(slot="header")
            b-container.d-flex.justify-content-between(fluid, v-if="!AppState.isStandalone", style="padding-left: 0")
              div
                span.page-title {{$t('subscription')}}
              div
                b-btn(v-if="showLicenseAddButton", variant="primary", size="sm", @click="addLicense()", style='color: white') {{$t('addLicense')}}
          b-card.table-card
            b-table.license-table(
              :fields="fields",
              :items="items",
              tbody-class="lmm-table-body")
              template(slot="HEAD_pay_expire", slot-scope="data") {{$t('end_time')}}
              template(slot="HEAD_pay_pay_type", slot-scope="data") {{$t('payment_type')}}
              template(slot="HEAD_pay_dev_vol", slot-scope="data") {{$t('device_vol')}}
              template(slot="HEAD_period", slot-scope="data") {{$t('remain')}}
              template(slot="HEAD_update", slot-scope="data") {{$t('renew')}}
              template(v-slot:cell(pay_start)="row")
                | {{row.item.pay_start | moment('YY-MM-DD')}}
              template(v-slot:cell(pay_expire)="row")
                | {{row.item.pay_expire | moment('YY-MM-DD')}}
              template(v-slot:cell(period)="row")
                template(v-if="row.item.isExpired") {{$t('expire')}}
                template(v-else) {{row.item.pay_expire | moment('from', today, true)}}
              template(v-slot:cell(pay_type)="row")
                | {{$t(row.item.pay_type)}}
              template(v-slot:cell(concurrent_sessions)="row")
                template(v-if="typeValue.basicProducts[row.item.pay_type] || row.item.pay_type === 'Free'")
                  | -
                template(v-else)
                  | {{ row.item.concurrent_sessions }}
              template(v-slot:cell(update)="row")
                b-btn.update-license-btn(v-if="row.item.pay_type !== 'Free'" size="sm", @click="updateLicense(row.item)")
                  span {{$t('renew')}}
    b-modal(
      size="xl",
      v-model="payment.show",
      header-class="lmm-common-popup-header",
      no-close-on-backdrop,
      centered
    )
      template.align-items-center(slot="modal-header")
        div
          h3.text-center {{$t(payment.title)}}
      div
        b-table.modal-table(
          :fields="payment.fields",
          :items="payment.items",
          tbody-class="lmm-table-body",
          outlined)
          template(slot="HEAD_start_date", slot-scope="data") {{$t('start_time')}}
          template(slot="HEAD_expire_date", slot-scope="data") {{$t('end_time')}}
          template(slot="HEAD_type", slot-scope="data") {{$t('device_type')}}
          template(slot="HEAD_vol", slot-scope="data") {{$t('device_vol')}}
          template(slot="HEAD_concurrent_sessions", slot-scope="data") {{$t('concurrent_users')}}
          template(slot="HEAD_period", slot-scope="data") {{$t('period')}}
          template(slot="HEAD_total", slot-scope="data") {{$t('total_price')}}
          template(v-slot:cell(start_date)="row") {{row.item.start_date | moment('YY-MM-DD')}}
          template(v-slot:cell(expire_date)="row") {{row.item.expire_date | moment('YY-MM-DD')}}
          template(v-slot:cell(type)="row")
            template(v-if="useCustom") {{customPaymentName}}
            template(v-else-if="payment.items[0].request_type === 'update'") {{row.item.type}}
            template(v-else)
              b-form-select(v-model="row.item.type", :options="payType", size="sm", @change="addLicense")
          template(v-slot:cell(vol)="row")
            span.text-right(v-if="payment.items[0].request_type === 'update'", @blur="calcTotal") {{row.item.vol}}
            b-form-input.text-right(v-else-if='isBasicProduct' v-model="row.item.vol", size="sm", @blur="calcTotal")
            span.text-right(v-else) {{payment.items[0].vol}}
          template(v-slot:cell(concurrent_sessions)="row")
            span.text-right(v-if="payment.items[0].request_type === 'update'", @blur="calcTotal") {{row.item.concurrent_sessions !== null ? row.item.concurrent_sessions : '-'}}
            span.text-right(v-else-if='isBasicProduct') -
            b-form-input.text-center(v-else v-model="row.item.concurrent_sessions", size="sm", @blur="calcTotal")
          template(v-slot:cell(period)="row")
            b-form-select(v-model="row.item.period", :options="filteredPeriods", size="sm", @input="calcTotal")
          template(v-slot:cell(total)="row")
            //span.discount(v-if="payment.discount > 0") {{payment.fullPay | comma}} {{$t('WON')}}
            span.price {{payment.total | comma}} {{$t('WON')}}
        div(v-if="payment.title === 'regist_service'" ).d-flex.justify-content-center.flex-column.align-items-center.desc-div
          span.text-center.m-4(v-html="$t('payment_tax_desc3')")
        div(v-else).d-flex.justify-content-center.flex-column.align-items-center.desc-div
          //div.text-center.mt-4(v-html="$t('payment_tax_desc4')")
          //b-btn.mt-2(v-if="AppState.license !== 'Free'", variant="primary", size="sm", @click="addLicense", style='color: white') {{$t('add_n', {v: $t('license')})}}
          span.text-center.m-4(v-html="$t('payment_tax_desc3')")

      template(slot="modal-footer")
        b-btn(size="sm", @click="cancelPay") {{$t('cancel')}}
        b-btn(size="sm", variant="primary", @click="goPay") {{$t('payment')}}
    div.invisible(v-if="payment.show")
      form(:action="`${AppState.Path.pay}/payreq_crossplatform.php`", method="POST", ref="form", target="POPUPW")
        input(type="hidden", name="CST_PLATFORM" value="service")
        input(type="hidden", name="CST_MID" value="linkmemine")
        input(type="hidden", name="LGD_CUSTOM_FIRSTPAY" value="")
        input(type="hidden", name="LGD_WINDOW_TYPE" value="iframe")
        input(type="hidden", name="LGD_MERTKEY" value="1d41a901c46c00aabc52e7ba27db73ca")
        input(type="hidden", name="LGD_ENCODING_NOTEURL" value="UTF-8")
        input(type="hidden", name="LGD_WINDOW_TYPE" value="iframe")
        input(type="hidden", name="LGD_OID" :value="payment.timestamp")
        input(type="hidden", name="LGD_AMOUNT" :value="payment.total")
        input(type="hidden", name="LGD_BUYER" :value="user.name")
        input(type="hidden", name="LMM_BUYERID" :value="user.mgrid")
        input(type="hidden", name="LGD_PRODUCTINFO" :value="payment.items[0].type")
        input(type="hidden", name="LGD_BUYEREMAIL" :value="user.email")
        input(type="hidden", name="LGD_TIMESTAMP" :value="payment.timestamp")
        input(type="hidden", name="LMM_PC_COUNT" :value="payment.items[0].vol")
        input(type="hidden", name="LMM_PK" :value="user.pk")
        input(type="hidden", name="LMM_PRODUCTINFO" :value="payment.items[0].type")
        input(type="hidden", name="LMM_COMPANY_FK" :value="user.company_fk")
        input(type="hidden", name="LMM_WARRANT_START" :value="payment.items[0].start_date | moment('YY-MM-DD HH:mm:ss')")
        input(type="hidden", name="LMM_WARRANT_END" :value="payment.items[0].expire_date | moment('YY-MM-DD HH:mm:ss')")
        input(type="hidden", name="LMM_UPDATE_PK" :value="payment.items[0].ref")
        input(type="hidden", name="LMM_TERM" :value="payment.items[0].period")
        input(type="hidden", name="LMM_PAY_FLAG" :value="payment.items[0].ref ? 1 : 0")
        input(type="hidden", name="LMM_CONCURRENT_SESSIONS" :value="payment.items[0].concurrent_sessions || Infinity")
        input(type="hidden", name="LMM_ACCOUNT_TYPE" :value="payment.items[0].account_type ? 1 : 0")
        input(v-if="useCustom", type="hidden", name="LMM_CUSTOM_PAYMENT" :value="customPaymentName")
</template>

<script>
import _ from 'lodash'
import moment from 'moment-timezone'
import {getUserData, user} from '@/api/access'

export default {
  name: "license-component",
  methods: {
    goPay() {
      // this.payment.show = false
      if (this.isPaymentDisabled) {
        return
      }
      
      this.payment.timestamp = new Date().getTime()
      this.paywin = window.open("about:blank", "POPUPW", "width=1024,height=726")
      this.$nextTick(() => {
        this.$refs.form.submit()
        // const formData = new FormData(this.$refs.form)
        // for (let [key, value] of formData.entries()) {
        //   console.log(`${key}: ${value}`);
        // }
      })

      if (this.checker) clearInterval(this.checker)
      this.checker = setInterval(() => {
        if (this.paywin.closed) {
          clearInterval(this.checker)
          this.checker = null
          this.paywin = null

          getUserData(null, err => {
            if (err) this.$log.error("[REFRESH USER DATA FAILED]")
            this.license = user().license
            this.user = user()
            this.payment.show = false
          })
        }
      }, 500)
    },
    cancelPay() {
      this.payment.show = false
    },
    calcTotal() {
      let item = this.payment.items[0]
      if (!item) return 0
      let total = 0
      this.payment.items[0].expire_date = moment(this.payment.items[0].start_date).add(item.period, 'M').format()
      
      // BasicProduct(Basic, Corporate) 제품군 확인 플러그 -> true 이면, BasicProduct 제품군
      this.isBasicProduct = !!this.typeValue.basicProducts[item.type]
      
      // largeScaleProducts 제품군은 년단위 선택 밖에 못하도록 정책이 되어있기 때문에, 구분하기 위함.
      this.isShowOnlyYearly = !!this.typeValue.largeScaleProducts[item.type]
      this.isPaymentDisabled = false
      
      // item.type 에 따른 total(총금액) 로직
      if (this.isBasicProduct) {
        total = this.calcBasicProducts(item)
      } else {
        total = this.calcLargeScaleProducts(item)
      }
      
      // 할인 로직
      let discount = this.calcDiscount(item, total)
      this.payment.discount = discount
      this.payment.total = total - discount
    },
    calcBasicProducts(params) {
      // basic 제품의 한계 기기 수 관련 로직
      // if (params.type === 'Basic' && params.vol > this.typeValue.basicProducts.Basic.maxDevices) {
      //   // params.vol = this.typeValue.basicProducts.Basic.maxDevices
      //   this.$awn.warning(this.$t('max_device_alert', { maxDevices: this.typeValue.basicProducts.Basic.maxDevices }))
      //   this.isPaymentDisabled = true
      // } else if (params.type === 'Corporate' && params.vol < this.typeValue.basicProducts.Corporate.minDevices) {
      //   // params.vol = this.typeValue.basicProducts.Corporate.minDevices
      //   this.$awn.warning(this.$t('min_device_alert', { minDevices: this.typeValue.basicProducts.Corporate.minDevices }))
      //   this.isPaymentDisabled = true
      // }
      this.payment.items[0].concurrent_sessions = null
      
      return params.vol * params.period * this.typeValue.basicProducts[params.type].price
    },
    calcLargeScaleProducts(params) {
      // largeScaleProducts 제품군은 년단위 선택 밖에 못함.
      if (params.period < 12) {
        params.period = 12
      }
      
      // concurrent_sessions 값 초기화. 기존 데이터에 해당 값이 없으면, 해당 타입의 기본값을 넣음.
      params.concurrent_sessions = parseInt(params.concurrent_sessions) || this.typeValue.largeScaleProducts[params.type].concurrentSessions
      
      // LMM1000 인 경우 동시접속자 3명 미만 선택 못하게 하는 코드
      if (params.type === 'LMM1000' && params.concurrent_sessions < this.typeValue.largeScaleProducts.LMM1000.concurrentSessions) {
        // params.concurrent_sessions = this.typeValue.largeScaleProducts.LMM1000.concurrentSessions
        this.$awn.warning(this.$t('min_concurrent_sessions_alert', { minConcurrentSessions: this.typeValue.largeScaleProducts.LMM1000.concurrentSessions }))
        this.isPaymentDisabled = true
      }
      
      params.vol = this.typeValue.largeScaleProducts[params.type].vol
      
      // LMM1000의 경우 3명 이상의 동시접속자에 대해서만 추가 비용 발생
      let concurrentSessionsPrice = 0
      let additionalSessions = params.concurrent_sessions
      if (params.type === 'LMM1000') {
        additionalSessions = Math.max(params.concurrent_sessions - 3, 0)
        concurrentSessionsPrice = additionalSessions * this.typeValue.largeScaleProducts.additionalConcurrentSessionsCost * params.period
      } else {
        additionalSessions = Math.max(params.concurrent_sessions - 1, 0)
        concurrentSessionsPrice = additionalSessions * this.typeValue.largeScaleProducts.additionalConcurrentSessionsCost * params.period
      }
      
      return params.period * this.typeValue.largeScaleProducts[params.type].price + concurrentSessionsPrice
    },
    calcDiscount(item, total) {
      let discountRate = 0
      
      if (this.isBasicProduct && item.period >= 12) {
        discountRate = parseFloat(this.typeValue.discountRate) / 100
      }

      return total * discountRate
    },
    addLicense(value) {
      // items 초기화
      this.initLicense(value)
      this.calcTotal()
      this.payment.show = true
    },
    // 라이선스의 정보를 초기화 한다. 결제하기 버튼을 누르면 value 가 없고, 결제 모달에서 제품유형을 변경하면 변경값이 value 가 된다.
    initLicense(value) {
      const date = moment()
      this.payment.title = "regist_service"
      
      // 초기 제품유형 결정. Free 사용자는 Basic 으로 변경하고, 그 이외에는 기존 제품유형 유지.
      // productType(원본 요금제)로 판정 — primaryProdType은 정규화(Free·LMM을 Corporate로 뭉갬)라 실제 상품 결정엔 부적합.
      const prodType = this.license.total.productType || this.license.total.primaryProdType
      let payment_type = value
          ? (value === 'Free' ? 'Basic' : value)
          : (prodType === 'Free' ? 'Basic' : prodType)

      // 상품표(basicProducts·largeScaleProducts)에 없는 등급(단독 Mdm·null 등)이면 Corporate로 폴백.
      // Mdm은 원래 상위 등급(isCorporate = licenseType !== 'Basic')이라 Basic보다 Corporate가 의미상 맞다.
      // 폴백 안 하면 calcTotal → calcLargeScaleProducts에서 largeScaleProducts[undefined].concurrentSessions
      // 접근으로 TypeError가 나 모달이 안 뜨고 결제하기 버튼이 반응 없어 보인다.
      if (!this.typeValue.basicProducts[payment_type] && !this.typeValue.largeScaleProducts[payment_type]) {
        payment_type = 'Corporate'
      }

      this.payment.items = [
        {
          ref: null,
          start_date: date.format(),
          expire_date: date.add(1, "M").format(),
          type: payment_type,
          vol: this.initVolValue(payment_type),
          period: 12,
          concurrent_sessions: this.initConcurrentValue(payment_type),
          request_type: 'add',
        },
      ]
    },
    updateLicense(t) {
      const isFirst = t.pay_type === "Free"
      
      let date = moment.utc(t.pay_expire)
      if (moment().diff(date, "seconds") > 0) date = moment()
      this.payment.title = "update_service"

      // 상품표(basicProducts·largeScaleProducts)에 없는 등급(단독 Mdm·미등록 값)이면 Corporate로 폴백.
      // Mdm은 상위 등급이라 Basic보다 Corporate가 의미상 맞다(결제하기 경로 initLicense와 동일한 방어).
      // 폴백 안 하면 calcTotal → calcLargeScaleProducts에서 largeScaleProducts[undefined].concurrentSessions
      // 접근으로 TypeError가 나 갱신 모달이 안 뜨고 갱신 버튼이 반응 없어 보인다.
      // (Mdm 계열은 단독·합성 LMM*Mdm 모두 상품표에 없어 Corporate로 폴백. Free 갱신의 Corporate는 표에 있어 무영향.)
      let payment_type = isFirst ? "Corporate" : t.pay_type
      if (!this.typeValue.basicProducts[payment_type] && !this.typeValue.largeScaleProducts[payment_type]) {
        payment_type = 'Corporate'
      }

      this.payment.items = [
        {
          ref: t.pay_pk,
          start_date: date.format(),
          expire_date: date.add(1, "M").format(),
          type: payment_type,
          vol: t.pay_dev_vol,
          period: 12,
          first: isFirst,
          account_type: t.account_type,
          concurrent_sessions: t.concurrent_sessions,
          request_type: 'update',
        },
      ]
      
      this.calcTotal()
      this.payment.show = true
    },
    initVolValue(paymentType) {
      if (this.typeValue.basicProducts[paymentType]) {
        return this.typeValue.basicProducts[paymentType].minDevices;
      } else if (this.typeValue.largeScaleProducts[paymentType]) {
        return this.typeValue.largeScaleProducts[paymentType].vol;
      }
      return null;
    },
    initConcurrentValue(paymentType) {
      if (this.typeValue.basicProducts[paymentType]) {
        return this.typeValue.basicProducts[paymentType].concurrentSessions;
      } else if (this.typeValue.largeScaleProducts[paymentType]) {
        return this.typeValue.largeScaleProducts[paymentType].concurrentSessions;
      }
      return null;
    },
  },
  beforeDestroy() {
    if (this.checker) {
      clearInterval(this.checker)
    }
    if (this.paywin && this.paywin.close) {
      this.paywin.close()
    }
  },
  data() {
    const userData = user()
    const useCustom = /.*?\|\d+/.test(userData.custom_payment)
    return {
      checker: null,
      paywin: null,
      isShowOnlyYearly: false,
      isBasicProduct: false,
      isPaymentDisabled: false,
      typeValue: {
        discountRate: '5%',
        basicProducts: {
          discountFlag: true,
          Basic: {
            price: 3850,
            minDevices: 1,
            maxDevices: 10,
            concurrentSessions: null,
          },
          Corporate: {
            price: 4510,
            minDevices: 1,
            concurrentSessions: null,
          },
        },
        largeScaleProducts: {
          discountFlag: false,
          additionalConcurrentSessionsCost: 55000,
          LMM100: {
            price: 37400,
            concurrentSessions: 1,
            vol: 100,
          },
          LMM300: {
            price: 94600,
            concurrentSessions: 1,
            vol: 300,
          },
          LMM500: {
            price: 176000,
            concurrentSessions: 1,
            vol: 500,
          },
          LMM1000: {
            price: 247500,
            concurrentSessions: 3,
            vol: 999999,
          },
        },
      },
      fields: [
        {
          key: 'pay_start',
          label: this.$t('start_date'),
          tdClass: 'text-center',
          thClass: 'text-center'
        },
        {
          key: "pay_expire",
          label: this.$t("expire_date"),
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "pay_type",
          label: this.$t("device_type"),
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "pay_dev_vol",
          label: this.$t("no_devices"),
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "concurrent_sessions",
          label: this.$t("concurrent_users"),
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "period",
          label: this.$t("period"),
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "update",
          label: this.$t("renew"),
          tdClass: "text-center",
          thClass: "text-center",
        },
      ],
      license: userData.license,
      user: userData,
      useCustom: useCustom,
      customPaymentName: useCustom ? userData.custom_payment.split("|")[0] : null,
      customPaymentPrice: useCustom ? parseInt(userData.custom_payment.split("|")[1]) : null,
      payment: {
        show: false,
        timestamp: 0,
        total: 0,
        discount: 0,
        fields: [
          {
            key: "start_date",
            label: this.$t("start_date"),
            tdClass: "text-center",
            thClass: "text-center",
          },
          {
            key: "expire_date",
            label: this.$t("expire_date"),
            tdClass: "text-center",
            thClass: "text-center",
          },
          {
            key: "type",
            label: this.$t("device_type"),
            tdClass: "text-center",
            thClass: "text-center",
          },
          {
            key: "vol",
            label: this.$t("device"),
            tdClass: "text-center",
            thClass: "text-center",
            thStyle: { width: "180px" },
          },
          {
            key: "concurrent_sessions",
            label: this.$t("concurrent_users"),
            thClass: "text-center",
            tdClass: "text-center",
            thStyle: { width: "120px" },
          },
          {
            key: "period",
            label: this.$t("period"),
            tdClass: "text-center",
            thClass: "text-center",
            thStyle: { width: '100px', minWidth: "80px" },
          },
          {
            key: "total",
            label: this.$t("total_price"),
            // tdClass: 'text-right',
            // thClass: 'text-right'
            tdClass: "text-center",
            thClass: "text-center",
            thStyle: { minWidth: "150px" },
          },
        ],
        items: [],
      },
      periods: [
        { value: 1, text: `1 ${this.$t("months")}` },
        { value: 2, text: `2 ${this.$t("months")}` },
        { value: 3, text: `3 ${this.$t("months")}` },
        { value: 4, text: `4 ${this.$t("months")}` },
        { value: 5, text: `5 ${this.$t("months")}` },
        { value: 6, text: `6 ${this.$t("months")}` },
        { value: 7, text: `7 ${this.$t("months")}` },
        { value: 8, text: `8 ${this.$t("months")}` },
        { value: 9, text: `9 ${this.$t("months")}` },
        { value: 10, text: `10 ${this.$t("months")}` },
        { value: 11, text: `11 ${this.$t("months")}` },
        { value: 12, text: `1 ${this.$t('years')}` },
        { value: 24, text: `2 ${this.$t('years')}` },
        // { value: 36, text: `3 ${this.$t('years')}` },
        // { value: 48, text: `4 ${this.$t('years')}` },
        // { value: 60, text: `5 ${this.$t('years')}` }
      ],
      payType: [
        {value: 'Basic', text: `${this.$t('Basic')}`},
        {value: 'Corporate', text: `${this.$t('Corporate')}`},
        {value: 'LMM100', text: `${this.$t('LMM100')}`},
        {value: 'LMM300', text: `${this.$t('LMM300')}`},
        {value: 'LMM500', text: `${this.$t('LMM500')}`},
        {value: 'LMM1000', text: `${this.$t('LMM1000+')}`},
      ]
    }
  },
  computed: {
    items() {
      let list = this.license.list
      list.sort((a, b) => b.expireTimeStamp - a.expireTimeStamp)
      return _.map(list, v => {
        if (v.isExpired) v._rowVariant = "active"
        return v
      })
    },
    today() {
      return moment().format()
    },
    filteredPeriods() {
      if (this.isShowOnlyYearly) {
        return this.periods.filter(period => period.value >= 12)
      }
      return this.periods
    },
    showLicenseAddButton() {
      return this.AppState.license === 'Free' || this.license.total.vol === 0
    },
  },
}
</script>

<style lang="scss" scoped>
.lmm-content-body-padded {
  padding: 0;
  margin: 0;
}

.row,
.col,
.container-fluid {
  margin: 0;
  padding: 0;
}

.page-wrap {
  padding: 1rem 1.5rem;
}

.page-header {
  padding: 0 1.5rem 0 1.5rem;
  margin-bottom: 0.5rem;
}

.card {
  border-radius: 0;
  .card-body {
    padding: 0;
  }
}

.btn-secondary {
  color: black !important;
  background-color: #ffffff;
  font-weight: 400;
}

.btn-primary {
  color: black;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #f7f7f7 !important;
  border: 1px solid #9c9c9c !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #cbcbcb !important;
  border: 1px solid #9c9c9c !important;
  font-weight: 400;
}

::v-deep .license-table {
  margin: 0;
  tr,
  td,
  th {
    padding: 0.5rem 1rem;
    position: relative;
    font-weight: 400;
  }
  th:nth-child(1),
  th:nth-child(2),
  th:nth-child(3),
  th:nth-child(4) {
    position: relative;
    padding-right: 0;
    text-align: left !important;
    width: 13% !important;
  }
  //th:nth-child(1)::after, th:nth-child(2)::after, th:nth-child(3)::after {
  //  content: "";
  //  position: absolute;
  //  right: 0;
  //  top: 50%;
  //  transform: translateY(-50%);
  //  height: 60%;
  //  border-right: 0.1rem solid #6F6F6F;
  //}
  td:nth-child(1),
  td:nth-child(2),
  td:nth-child(3),
  td:nth-child(4) {
    position: relative;
    padding-right: 0;
    text-align: left !important;
    color: #6f6f6f;
  }
}

h3 {
  color: black;
  margin-bottom: 0;
  font-weight: 500;
  font-size: 1.5rem;
}

.header-desc-div {
  font-size: 1.2rem;
  font-weight: bold;
}

.desc-div {
  color: #6f6f6f;
}

.discount {
  display: inline-block;
  padding-right: 10px;
  text-decoration: line-through;
  color: #afafaf;
}

::v-deep .modal-xl {
  max-width: 1200px;
}
</style>
